<template lang="pug">
  .cancel-reasons.xs-12
    SectionBlock(:transparent="true").no-space-section
      BackButton(:url="backUrl")
      transition(name="fade").row
        .reasons-wrap
          SectionTitle(text="Cancel Subscription" data-mr-ass="cancel-reasons").text-center
          p.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak {{ info.first_name}}, we hear you'd like to cancel your Membership. First, help us understand what is going on.
          .reasons
            RoundButton(v-for="reason in cancelReasons" :key="reason.id" @round-button-click="reasonClick(reason)" :selected="selectedBtn(reason)" data-mr-ass="reason-to-cancel").large {{ reason.reason }}

          .other-reasons(v-if="showOtherReasons")
            hr
            .reasons
              RoundButton(v-for="reason in otherReasons" :key="reason.id" @round-button-click="reasonClick(reason)" :selected="selectedBtn(reason)").large {{ reason.reason }}

            .reason-note
              textarea(v-model="cancelComment")

            .text-center
              button(@click="otherReasonSubmit" :class="{ disabled: !otherReasonSelected }").mr-btn.btn-fixed-width.font-xsmall.submit-btn Next

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import SectionBlock from "../../../SectionBlock";
  import BackButton from "../../../BackButton";
  import SectionTitle from "../../../../SectionTitle";
  import { shuffleArray } from "../../../../../utilities/mrVueUtils";

  import SubInEdit from '../SubInEdit';
  import RoundButton from "../../../../RoundButton";

  export default {
    name: "EditAutoDeliveryCancelReasons",
    extends: SubInEdit,

    data() {
      return {
        showOtherReasons: false,
        mainReasons: [ //- Hard coded for the A/B test. If this wins, need to update current reasons to match these
          {
            id: 9,
            disposition_reason_id: 30,
            reason: 'Not satisfied with the color',
            tag: 'color_issue_cancel_chat',
            route: 'cancelColorIssue'
          },
          {
            id: 1,
            disposition_reason_id: 26,
            reason: 'Don\'t need more color right now',
            tag: 'dont_need_more_cancel_chat',
            route: 'cancelTooMuch'
          },
          {
            id: 2,
            disposition_reason_id: 32,
            reason: 'Prefer to order one-at-a-time',
            tag: 'prefer_one_cancel_chat',
            route: 'cancelTooMuch'
          },
          {
            id: 3,
            disposition_reason_id: 20,
            reason: 'Issue with price',
            tag: 'price_issue_cancel_chat',
            route: 'cancel',
            customMsg: "We’re so sorry you are having an issue with your Membership. Our licensed colorists are always available to chat about any problems you may be having."
          },
          {
            id: 11,
            disposition_reason_id: 15,
            reason: 'Didn\'t cover grays',
            tag: 'gray_coverage_cancel_chat',
            route: 'cancel',
            customMsg: "We're so sorry you didn't get enough gray coverage. Our licensed colorists have a ton of tips on how to cover stubborn grays—reach out and your next box is <span class='bold'>FREE</span>"
          },
          {
            id: 18,
            disposition_reason_id: 12,
            reason: 'Color is too dark',
            tag: 'too_dark_cancel_chat',
            route: 'cancel',
            customMsg: "We're so sorry your color came out too dark. Our licensed colorists can help you get a better result—reach out and your next box is <span class='bold'>FREE</span>"
          }
        ],

        otherReasons: [
          {
            id:4,
            disposition_reason_id: 29,
            reason: 'Difficulty using website or mobile app',
            tag: 'website_difficulty_cancel_chat',
            route: 'cancel',
            customMsg: "We’re so sorry you are having difficulty using our website or mobile app. Our colorists are always available to help with any issues you may be having."
          },
          {
            id:5,
            disposition_reason_id: 24,
            reason: 'Product didn\'t arrive as expected',
            tag: 'didnt_arrive_cancel_chat',
            route: 'cancel',
            customMsg: "We’re so sorry your product didn’t arrive as expected. Our licensed colorists are always available to help with any issues you may be having."
          }
        ],

        extraReason: { id: 'Other', disposition_reason_id: null, reason: 'Other' },

      }
    },

    components: {
      RoundButton,
      SectionTitle,
      BackButton,
      SectionBlock
    },

    computed: {
      ...mapState('customer', [
        'info'
      ]),

      ...mapState('subscriptions', [
        'cancelReasons',
        'cancelData'
      ]),

      cancelReasons() {
        shuffleArray(this.mainReasons);
        this.mainReasons.push(this.extraReason);
        return this.mainReasons;
      },

      backUrl() {
        return `/dashboard/purchases/edit-auto-delivery/${this.$route.params.subId}`
      },

      otherReasonSelected() {
        return this.otherReasons.map(r => r.id).includes(this.cancelData.reason.id);
      },

      cancelComment: {
        get() {
          return this.cancelData.comment;
        },

        set(val) {
          this.setCancelComment(val);
        }
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'editAutoDeliveryCancelOfferModal',
        'clearCancelData',

        'editAutoDeliveryPauseModal',
        'editAutoDeliveryChooseDateModal'
      ]),

      ...mapMutations('subscriptions', [
        'setCancelReason',
        'setCancelComment'
      ]),

      selectedBtn(reason) {
        return reason.id == this.cancelData.reason.id;
      },

      reasonClick(reason) {
        this.setCancelReason(reason);

        if (['Other', 4, 5].includes(this.cancelData.reason.id || '')) {
          this.showOtherReasons = true;
        } else {
          this.showOtherReasons = false;
          if (this.cancelData.reason.route) {
            this.$router.push({ name: this.cancelData.reason.route });
          }
        }
      },

      otherReasonSubmit() {
        this.$router.push({ name: this.cancelData.reason.route });
      }
    },

    mounted() {
      this.clearCancelData();
    }
  }
</script>

<style scoped lang="stylus">
  .cancel-reasons
    .reasons-wrap
      max-width 43em
      margin auto

      >p
        padding 2em 0

      .reasons
        display flex
        align-items flex-start
        flex-wrap wrap
        justify-content space-around

        .round-button
          width 49%

      .other-reasons
        hr
          margin 2em 0
          border-color #ccc

        .reason-note
          max-width 25em
          margin 1em auto 2em

    @media mq-mobile
      .reasons-wrap
        .reasons
          .round-button
            width 100%

    @media mq-tablet
      .reasons-wrap
        .reasons
          .round-button
            width 100%

</style>
